import React from 'react';
import Tippy from '@tippy.js/react';

import { Value } from './CodeSnippet.style';
import { copyStringToBuffer } from '../../utils/common';

interface ICodeSnippetProps {
  className?: string;
  children: any | any[];
}

const CodeSnippet: React.FC<ICodeSnippetProps> = ({ children, className }) => {
  return (
    <div className={className} onClick={() => copyStringToBuffer(children)}>
      <Tippy
        arrow={true}
        placement="top"
        animation="fade"
        boundary="window"
        trigger="click"
        content={'Copied'}
      >
        <Value>{children}</Value>
      </Tippy>
    </div>
  );
};

export default CodeSnippet;
